import { Box, CircularProgress, IconButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { theme } from "../../Assets/Theme/theme";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../../Assets/Constants";
import TextInput from "../../Components/Common/TextInput";
import CustomButton from "../../Components/Common/CustomButton";
import logo from "../../Assets/Images/logo.png";
import login_bg from "../../Assets/Images/login-bg.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MailIcon from "@mui/icons-material/Mail";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import otpImage from "../../Assets/Images/confidential-email.png";

function OTP({ email }) {
    const { state } = useLocation()
    const [errors, setErrors] = useState([])
    const [loading, setLoading] = useState(false)
    const [loadingResend, setLoadingResend] = useState(false)
    const [otp, setOtp] = useState("");
    const [isHovered, setIsHovered] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${BASE_URL}/forgot/step2/password`, {
                email: state?.email,
                otp: otp,
            });

            if (response?.data) {
                toast.success(response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    style: { backgroundColor: 'orange', color: 'white' },
                });
                navigate('/new-password', { state: { email: state?.email, otp: otp } });
            } else {
                toast.error("Invalid OTP. Please try again.", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                toast.error(
                    error.response?.data?.message,
                    {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    }
                );
            } else {
                toast.error(
                    error.response?.data?.error[0]?.msg,
                    {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    }
                );
            }
        } finally {
            setLoading(false);
        }
    };

    const handleResend = async () => {
        setLoadingResend(true);
        try {
            const response = await axios.post(`${BASE_URL}/forgot/step1/password`, {
                email: state?.email,
            });

            if (response?.data?.status) {
                toast.success("Otp code has been resent to your email successfully", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    style: { backgroundColor: 'orange', color: 'white' },
                });
                setOtp('')
            } else {
                toast.error("Failed", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        } catch (error) {
            toast.error(
                error.response?.data?.message || "Unable to send OTP. Please try again."
            );
        } finally {
            setLoadingResend(false);
        }
    };

    const getErrorMessage = (field) => {
        const fieldError = errors?.find((err) => err?.path === field);
        return fieldError?.msg || null;
    };

    const clearErrorMessage = (field) => {
        setErrors((prevErrors) => prevErrors.filter((err) => err?.path !== field));
    };

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === "Enter") {
                handleSubmit()
            }
        };

        window.addEventListener("keypress", handleKeyPress);

        return () => {
            window.removeEventListener("keypress", handleKeyPress);
        };
    }, [otp]);

    return (
        <Box display={"flex"} overflow={"hidden"}>
            {/* Left Section */}
            <Box
                width={"62%"}
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}
                sx={{
                    "@media (max-width:900px)": {
                        width: "100%",
                    },
                }}
            >
                {loadingResend ? <CircularProgress size={30} sx={{ color: theme.colors.orange }} /> : <Box sx={{
                    padding: "20px",
                    backgroundColor: "#f8f4ea",
                    borderRadius: "10px", width: "60%"
                }}>
                    <Box
                        marginBottom={3}
                        textAlign="center"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        gap={0}
                    >
                        {/* <VpnKeyIcon style={{ fontSize: "48px", color: "#FF9800", position: 'relative', left: 20 }} /> */}
                        {/* <MailIcon style={{ fontSize: "100px", color: theme.colors.orange }} />
                        <Box
                            style={{
                                display: "inline-block",
                                backgroundColor: "#F5F5F5",
                                borderRadius: "4px",
                                padding: "4px 4px",
                                fontSize: "12px",
                                fontWeight: "bold",
                                color: "#333",
                                position: 'relative', right: 40, top: 15
                            }}
                        >
                            ******
                        </Box> */}
                        <img
                            src={otpImage}
                            alt={"Key image"}
                            style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "contain",
                            }}
                        />
                    </Box>

                    {/* Title */}
                    <Typography
                        variant="h5"
                        fontWeight={700}
                        textAlign="center"
                        marginBottom={1}
                        sx={{ fontFamily: "Nunito, sans-serif" }}
                    >
                        Verify your email address
                    </Typography>

                    <Typography
                        variant="body2"
                        color="#6c757d"
                        textAlign="center"
                        marginBottom={2}
                        sx={{ fontFamily: "Nunito, sans-serif" }}
                    >
                        Enter the OTP sent to your email address to proceed with verification.
                    </Typography>
                    <Box
                        display="flex"
                        flexWrap="wrap"
                        justifyContent="center"
                        gap="15px"
                        marginBottom={3}
                        width="100%"
                        sx={{
                            "@media (max-width: 600px)": {
                                gap: "5px",
                            },
                            "@media (max-width: 600px)": {
                                flexWrap: "wrap",
                                justifyContent: "space-between",
                                gap: "8px",
                            },
                        }}
                    >
                        {Array(6)
                            .fill("")
                            .map((_, index) => (
                                <input
                                    key={index}
                                    type="text"
                                    maxLength={1}
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                        textAlign: "center",
                                        fontSize: "20px",
                                        fontWeight: "bold",
                                        borderRadius: "8px",
                                        border: "2px solid #e0e0e0",
                                        outline: "none",
                                        transition: "border 0.2s ease-in-out",
                                    }}
                                    onFocus={(e) => (e.target.style.border = "2px solid #FF7900")}
                                    onBlur={(e) => (e.target.style.border = "2px solid #e0e0e0")}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (!isNaN(value) && value !== "") {
                                            setOtp((prevOtp) => {
                                                const otpArray = prevOtp.split("");
                                                otpArray[index] = value;
                                                return otpArray.join("");
                                            });

                                            if (index < 5) {
                                                const nextInput = document.querySelector(
                                                    `input:nth-of-type(${index + 2})`
                                                );
                                                if (nextInput) {
                                                    nextInput.focus();
                                                }
                                            }
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Backspace" && !e.target.value && index > 0) {
                                            const prevInput = document.querySelector(
                                                `input:nth-of-type(${index})`
                                            );
                                            if (prevInput) {
                                                prevInput.focus();
                                            }
                                        }
                                    }}
                                />
                            ))}
                    </Box>

                    <CustomButton
                        onClick={handleSubmit}
                        style={{
                            width: "50%",
                            margin: "0 auto",
                            display: "block",
                        }}
                    >
                        {loading ? <CircularProgress size={30} sx={{ color: "white" }} /> : 'Verify email'}
                    </CustomButton>
                    <Box textAlign="center" marginBottom={2} marginTop={2} onClick={handleResend}>
                        <Typography
                            variant="body2"
                            sx={{
                                fontFamily: "Nunito, sans-serif",
                                color: "#6c757d",
                            }}
                        >
                            <span
                                style={{
                                    color: theme.colors.orange,
                                    cursor: "pointer",
                                    textDecoration: isHovered ? "underline" : "none",
                                }}
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}
                            >
                                Resend Code
                            </span>
                        </Typography>
                    </Box>
                </Box>}
            </Box>

            {/* Right Section */}
            <Box
                width="35%"
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                    "@media (max-width: 900px)": {
                        display: "none",
                    },
                    "@media (min-width: 900px) and (max-width: 1200px)": {
                        height: "20vh",
                    },
                    "@media (min-width: 900px)": {
                        height: "90vh",
                    },
                }}
            >
                <img
                    src={login_bg}
                    alt="Login Background"
                    style={{ width: "100%", height: "100%" }}
                />
            </Box>
        </Box>
    );
}

export default OTP;

